module.exports = __webpack_public_path__ + "img/certificate.ea76a480.jpg";